import { render, staticRenderFns } from "./CornerRightTop.vue?vue&type=template&id=06e9bfe8&scoped=true&"
import script from "./CornerRightTop.vue?vue&type=script&lang=js&"
export * from "./CornerRightTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e9bfe8",
  null
  
)

export default component.exports